import { BReactComponent } from 'blocks-cloud/b-react-component';
import { IS_PUBLIC, IS_STOCK } from 'reactApp/appHelpers/configHelpers';
import { getCurrentFolder, isMountedOrSharedFolder } from 'reactApp/modules/storage/storage.selectors';
import { store } from 'reactApp/store';
import { EditorHeaderContainer as EditorHeader } from 'reactApp/ui/EditorHeader/EditorHeaderContainer';

export const updateEditorHeaderLicenseExpired = () => {
    const header = document.querySelector('#react-header');

    if (!header) {
        return;
    }

    const reactHeader = new BReactComponent({
        ReactComponent: EditorHeader,
    });

    const state = store.getState();
    const item = getCurrentFolder(state);
    const isMounted = isMountedOrSharedFolder(state, item).isMounted;

    reactHeader.renderTo(header, {
        props: {
            isPublic: !!IS_PUBLIC,
            isStock: Boolean(IS_STOCK),
            enableFavorites: !IS_PUBLIC && !isMounted,
            licenseExpired: true,
        },
    });
};
